import { render, staticRenderFns } from "./SgQuickPay.vue?vue&type=template&id=39316981&"
import script from "./SgQuickPay.vue?vue&type=script&lang=js&"
export * from "./SgQuickPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports